<template>
    <span>{{ prefix + time + suffix }}</span>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "PassedTimeCounter",
    props: {
        date: {
            type: String,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        suffix: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            time: "00:00",
            interval: null,
        };
    },
    methods: {
        start() {
            this.interval = setInterval(this.incrementTime, 1000);
        },
        incrementTime() {
            let [minutes, seconds] = this.time.split(":").map(Number);
            seconds++;
            if (seconds >= 60) {
                minutes++;
                seconds = 0;
            }
            this.time = `${minutes.toString().padStart(2, "0")}:${Math.floor(seconds).toString().padStart(2, "0")}`;
        },
    },
    computed: mapState({
        timeDiff: (state) => state.auth.timeDiff,
    }),
    mounted: function () {
        if (this.date) {
            const diff = this.endDate
                ? moment.duration(moment(this.endDate).add(this.timeDiff, "seconds").diff(moment(this.date)))
                : moment.duration(moment().add(this.timeDiff, "milliseconds").diff(moment(this.date)));
            let totalSeconds = diff.asSeconds();
            let minutes = Math.floor(totalSeconds / 60);
            let seconds = totalSeconds % 60;
            this.time = `${minutes.toString().padStart(2, "0")}:${Math.floor(seconds).toString().padStart(2, "0")}`;
        }
        this.start();
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
};
</script>

<style scoped></style>
